import React from "react"
import { useSolutionLevelScheduledReportExportContext } from "contexts/SolutionLevelScheduledReportExportContext"
import SubmissionFilters from "shared/ScheduledReportExport/SubmissionFilters"

const NewSolutionLevelScheduledReportExportSubmissionFilters = () => {
  const {
    dateFilterType,
    startDate,
    submissionPreviousRangeLength,
    submissionPreviousRangeUnit,
    setSubmissionPreviousRangeLength,
    lengthOptions,
  } = useSolutionLevelScheduledReportExportContext()

  return (
    <SubmissionFilters
      dateFilterType={dateFilterType}
      startDate={startDate}
      submissionPreviousRangeLength={submissionPreviousRangeLength}
      submissionPreviousRangeUnit={submissionPreviousRangeUnit}
      setSubmissionPreviousRangeLength={setSubmissionPreviousRangeLength}
      lengthOptions={lengthOptions}
    />
  )
}

export default NewSolutionLevelScheduledReportExportSubmissionFilters
